import { Default, Detail, List,  Create } from "./views";



const Module = {
    name: "notificationUsers",
    defaultRoutePath: "/notifications/user",
    menuItemScope: "notifications",
    menuItemName: "notificationUsers",

    routes: [
        {
            path: "/notifications/user",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
       
    ],
    
}

export default Module;
